import { MessageSquareMoreIcon, DropdownMenu } from '@buffer-mono/popcorn'

import { STATUS_LABELS } from './types'
import type { FilterStatus } from './types'

import type { JSX } from 'react'

const FILTER_STATUSES = ['unreplied', 'replied', 'dismissed', 'all'] as const

type StatusFilterOption = (typeof FILTER_STATUSES)[number]

function isFilterStatus(value: string): value is StatusFilterOption {
  return FILTER_STATUSES.some((status) => status === value)
}

export type StatusFilterSubMenuProps = {
  status: FilterStatus
  onStatusChange: (status: StatusFilterOption) => void
}

export function StatusFilterSubMenu({
  status,
  onStatusChange,
}: StatusFilterSubMenuProps): JSX.Element {
  return (
    <DropdownMenu.Sub>
      <DropdownMenu.SubTrigger>
        <MessageSquareMoreIcon /> Filter by status
      </DropdownMenu.SubTrigger>
      <DropdownMenu.SubMenu>
        <DropdownMenu.RadioGroup
          value={status}
          onChange={(value): void => {
            if (isFilterStatus(value)) onStatusChange(value)
          }}
        >
          <DropdownMenu.RadioItem value="all">
            {STATUS_LABELS.all}
          </DropdownMenu.RadioItem>
          <DropdownMenu.RadioItem value="unreplied">
            {STATUS_LABELS.unreplied}
          </DropdownMenu.RadioItem>
          <DropdownMenu.RadioItem value="replied">
            {STATUS_LABELS.replied}
          </DropdownMenu.RadioItem>
          <DropdownMenu.RadioItem value="dismissed">
            {STATUS_LABELS.dismissed}
          </DropdownMenu.RadioItem>
        </DropdownMenu.RadioGroup>
      </DropdownMenu.SubMenu>
    </DropdownMenu.Sub>
  )
}
